import React, { useContext } from 'react';

export const DocumentsContext = React.createContext();
export const useDocuments = () => useContext(DocumentsContext);